<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import ProfileImage from '~/components/objects/Discussion/Profile/ProfileImage.vue'

const i18n = useI18n()

const trusts = ref([
    {
        title: i18n.t('trust.title1'),
        text: i18n.t('trust.text1'),
    },
    {
        title: i18n.t('trust.title2'),
        text: i18n.t('trust.text2'),
    },
    {
        title: i18n.t('trust.title3'),
        text: i18n.t('trust.text3'),
    },
    {
        title: i18n.t('trust.title4'),
        text: i18n.t('trust.text4'),
    },
])
</script>

<template>
    <div v-if="$tm('trust.showTrust')" class="trust-container">
        <div class="trusts">
            <h3>{{ $t('trust.headline') }}</h3>

            <div class="trust__badge">
                <img v-if="$t('trust.linkTrustBadge')" :src="$t('trust.linkTrustBadge')" width="52" height="52" alt="Arukereso" />
            </div>
            <div v-for="(trust, index) in trusts" :key="index" class="trust">
                <div class="trust__title">{{ trust.title }}</div>
                <p class="trust__text" v-html="trust.text" />
            </div>
        </div>

        <ObjectsRating v-if="$t('trust.review').length" :rating="10" :total="0" :box="true" :more-info="false" prefix="100 %" />

        <div v-if="$t('trust.review').length" class="user__wrapper">
            <ProfileImage :is-pilulka-employee="false" :has-shield="false" />
            <div class="user">
                <div class="user__name">{{ $t('trust.review') }}</div>
                <div class="user__verify">{{ $t('reviewClub.best.verified') }}</div>
            </div>
        </div>

        <p v-if="$t('trust.textReview').length">{{ $t('trust.textReview') }}</p>
    </div>
</template>

<style lang="scss" scoped>
.trust-container {
    box-shadow: $box-shadow;
    padding: 20px;
    margin-top: 17px;

    .trusts {
        display: grid;
        grid-template-columns: 18% 41% 41%;
        margin-bottom: 20px;

        h3 {
            margin-top: 0;
            grid-column-start: 1;
            grid-column-end: 4;
            grid-row-start: 1;
            grid-row-end: 3;
        }

        .trust {
            padding: 6px;

            &__badge {
                grid-column-start: 1;
                grid-row-start: 3;
                grid-row-end: 5;
                padding-right: 5px;
                padding-top: 8px;
            }

            &__title {
                color: $color-green-dark;
                font-size: 16px;
                font-weight: 590;
            }

            &__text {
                font-size: 12px;
                margin: 5px 0;
            }
        }
        .trust-list {
            grid-template-columns: 50% 50%;
        }
    }
}

.user__wrapper {
    margin-top: 15px;
    display: flex;
    flex-direction: row;

    .user {
        display: flex;
        flex-direction: column;
        padding-left: 15px;

        &__name {
            color: $color-dark;
            font-size: 16px;
            font-weight: 500;
            margin-top: 5px;
        }
        &__verify {
            display: inline-block;
            font-size: 12px;
            color: $color-green-dark;
            padding: 2px 12px;
            border-radius: 25px;
            background: rgba(99, 135, 77, 0.1);
            margin-top: 7px;
        }
    }
}
</style>
